import { Title } from "@mantine/core";
import React from "react";

export default function Notifications() {
  return <Title ta="center">Notification Page</Title>;
}
